import appStore from '../img/appStoreLogo.svg';
import googlePlay from '../img/googlePlayLogo.png';

export function Appstore({ screenSize }: { screenSize: string }) {
  const imgHeight = 50;

  const appStoreLink = 'https://apps.apple.com/dk/app/kolding-parkering/id6737193569';
  const googlePlayLink = 'https://play.google.com/store/apps/details?id=com.sensade.kolding_parkering&hl=da';

  return (
    <div
      className="appstore-box"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: screenSize === 'mobile' ? 'center' : 'left',
        padding: '1em',
        paddingBottom: 'calc(env(safe-area-inset-bottom, 1em))',
        background: 'transparent'
      }}
    >
      <a
        href={appStoreLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          border: '0px',
          display: 'inline-block',
          width: 'auto',
          height: 'auto',
          backgroundColor: 'transparent',
        }}
      >
        <img
          src={appStore}
          alt="Download on the App Store"
          style={{ marginLeft: '0px' }}
          width="auto"
          height={imgHeight}
        />
      </a>
      <div style={{ width: '10px' }} />
      <a
        href={googlePlayLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          width: 'auto',
          height: 'auto',
          backgroundColor: 'transparent',
        }}
      >
        <img
          src={googlePlay}
          alt="Get it on Google Play"
          style={{ marginLeft: '0px', paddingBottom: '2px' }}
          width="auto"
          height={imgHeight}
        />
      </a>
    </div>
  );
}

